var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var GameController = /** @class */ (function () {
    function GameController() {
    }
    /*****************************************************************************************************
        * Is using route "api/game" and http method "POST" to call the back-end.
    Creates a game from a quiz
    
        * @param {GameRequestDto} gameRequest  Necessary information to create the game
        * @returns {GameDownloadDto} The game
    ******************************************************************************************************/
    GameController.CreateGame = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.gameRequest
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/referenced/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {GameRequestDto} gameRequest
        * @returns {GameDownloadDto}
    ******************************************************************************************************/
    GameController.CreateGameReferenced = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/referenced/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.gameRequest
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}" and http method "POST" to call the back-end.
    Creates a replay game
    
        * @param {string} gameId  The id of the game that should be copied
        * @returns {GameDownloadDto} The game
    ******************************************************************************************************/
    GameController.CreateGameByGameId = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/replayjoin/{gameId}" and http method "POST" to call the back-end.
    Creates a copy of a game
    
        * @param {string} gameId  The id of the game that should be copied
        * @returns {void}
    ******************************************************************************************************/
    GameController.MakeReplayPlayersJoin = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/replayjoin/{gameId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}/join" and http method "POST" to call the back-end.
    Joins a versus game
    
        * @param {string} gameId  the id of the game to join
        * @returns {JoinGameDto}
    ******************************************************************************************************/
    GameController.JoinGame = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}/join", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}/start" and http method "POST" to call the back-end.
    
        * @param {string} gameId
        * @returns {void}
    ******************************************************************************************************/
    GameController.StartGame = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}/start", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}" and http method "DELETE" to call the back-end.
    Deletes a game
    
        * @param {string} gameId  The id of the game that should be deleted
        * @returns {AnswerQuestionResultDto}
    ******************************************************************************************************/
    GameController.DeleteGame = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}/FourPicturesOneSolutionQuestionUserAnswer" and http method "POST" to call the back-end.
    Answer a FourPicturesOneSolutionQuestion
    
        * @param {string} gameId  The game where the question is answered
        * @param {FourPicturesOneSolutionUserAnswer} userAnswer  The answer to the question
        * @returns {AnswerQuestionResultDto} Information to the answered question or nothing
    ******************************************************************************************************/
    GameController.AnswerFourPictureQuestion = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}/FourPicturesOneSolutionQuestionUserAnswer", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.userAnswer
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}/MultipleChoiceQuestionUserAnswer" and http method "POST" to call the back-end.
    Answer a MultipleChoiceQuestion
    
        * @param {string} gameId  The game where the question is answered
        * @param {MultipleChoiceUserAnswer} userAnswer  The answer to the question
        * @returns {AnswerQuestionResultDto} Information to the answered question or nothing
    ******************************************************************************************************/
    GameController.AnswerMultipleChoiceQuestion = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}/MultipleChoiceQuestionUserAnswer", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.userAnswer
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}/SortQuestionUserAnswer" and http method "POST" to call the back-end.
    Answer a SortQuestion
    
        * @param {string} gameId  The game where the question is answered
        * @param {SortUserAnswer} userAnswer  The answer to the question
        * @returns {AnswerQuestionResultDto} Information to the answered question or nothing
    ******************************************************************************************************/
    GameController.AnswerSortQuestion = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}/SortQuestionUserAnswer", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.userAnswer
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}/CorrelatePairsQuestionUserAnswer" and http method "POST" to call the back-end.
    Answer a CorrelatePairsQuestion
    
        * @param {string} gameId  The game where the question is answered
        * @param {CorrelatePairsQuestionUserAnswer} userAnswer  The answer to the question
        * @returns {AnswerQuestionResultDto} Information to the answered question or nothing
    ******************************************************************************************************/
    GameController.AnswerCorrelatePairsQuestion = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}/CorrelatePairsQuestionUserAnswer", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.userAnswer
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}/MarkInPictureQuestionUserAnswer" and http method "POST" to call the back-end.
    Answer a MarkInPictureQuestion
    
        * @param {string} gameId  The game where the question is answered
        * @param {MarkInPictureUserAnswer} userAnswer  The answer to the question
        * @returns {AnswerQuestionResultDto} Information to the answered question or nothing
    ******************************************************************************************************/
    GameController.AnswerMarkInPictureQuestion = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}/MarkInPictureQuestionUserAnswer", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.userAnswer
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}/MarkAreaInPictureQuestionUserAnswer" and http method "POST" to call the back-end.
    Answer a MarkAreaInPictureQuestion
    
        * @param {string} gameId  The game where the question is answered
        * @param {MarkAreaInPictureUserAnswer} userAnswer  The answer to the question
        * @returns {AnswerQuestionResultDto} Information to the answered question or nothing
    ******************************************************************************************************/
    GameController.AnswerMarkAreaInPictureQuestion = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}/MarkAreaInPictureQuestionUserAnswer", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.userAnswer
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}/EstimateQuestionUserAnswer" and http method "POST" to call the back-end.
    Answer a EstimateQuestion
    
        * @param {string} gameId  The game where the question is answered
        * @param {EstimateUserAnswer} userAnswer  The answer to the question
        * @returns {AnswerQuestionResultDto} Information to the answered question or nothing
    ******************************************************************************************************/
    GameController.AnswerEstimateQuestion = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}/EstimateQuestionUserAnswer", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.userAnswer
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/search" and http method "POST" to call the back-end.
    Searches games with the given filters
    
        * @param {GameFilterDto} filter  The filter
        * @returns {GameDownloadDto[]} All games that where found for the given filter
    ******************************************************************************************************/
    GameController.SearchGames = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/search", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}/result" and http method "GET" to call the back-end.
    Returns the game result for the given game id
    
        * @param {string} gameId  The game id
        * @returns {GameResultDto[]} The game result for the given game
    ******************************************************************************************************/
    GameController.GetGameResult = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}/result", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/quiz/{quizId}/game/result" and http method "GET" to call the back-end.
    Returns all the game results for a given quiz id
    
        * @param {string} quizId  The quiz id
        * @returns {GameResultDto[]} All game results that exist for the given quiz id and the current user
    ******************************************************************************************************/
    GameController.GetGameResultsForQuiz = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/quiz/{quizId}/game/result", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/quiz/{quizId}/game/highscore/{top}" and http method "GET" to call the back-end.
    Returns given number from the top of the highscore list as game results
    
        * @param {string} quizId  The quiz of the highscore
        * @param {number} top  The number of results
        * @returns {GameResultDto[]}
    ******************************************************************************************************/
    GameController.GetTopGameHighScoreForQuiz = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/quiz/{quizId}/game/highscore/{top}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/quiz/{quizId}/game/highscore" and http method "GET" to call the back-end.
    Returns given number from the top of the highscore list as game results
    
        * @param {string} quizId  The quiz of the highscore
        * @returns {GameResultDto[]}
    ******************************************************************************************************/
    GameController.GetGameHighScoreForQuiz = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/quiz/{quizId}/game/highscore", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/{gameId}/hidden/{hidden}" and http method "PATCH" to call the back-end.
    Sets a game's visibility for the highscore
    
        * @param {string} gameId  the id of the game
        * @param {boolean} hidden  hidden value
        * @returns {void}
    ******************************************************************************************************/
    GameController.SetGameVisibility = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/{gameId}/hidden/{hidden}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/quiz/{groupId}/game" and http method "GET" to call the back-end.
    Returns reduced quiz information for a user that wants to play a quiz within the given group
    
        * @param {string} groupId  The id of the group
        * @returns {QuizForGameDto[]} All quiz that were found for the group as reduced elements
    ******************************************************************************************************/
    GameController.GetQuizForGame = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/quiz/{groupId}/game", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/question/statistic" and http method "POST" to call the back-end.
    Returns question results that are filtered with a given filter.
    
        * @param {GameFilterDto} filter  filters the questions by several properties
        * @returns {QuestionStatisticElementDto[]}
    ******************************************************************************************************/
    GameController.GetQuestionStatistic = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/question/statistic", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/statistic" and http method "POST" to call the back-end.
    Returns games that are filtered with a given filter.
    
        * @param {GameFilterDto} filter  filters the games by several properties
        * @returns {GameResultDto[]}
    ******************************************************************************************************/
    GameController.GetGameStatistic = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/statistic", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/statistic/firstAndBest" and http method "POST" to call the back-end.
    Returns games that are filtered with a given filter.
    
        * @param {GameFilterDto} filter  filters the games by several properties
        * @returns {FirstAndBestGameResultDto[]}
    ******************************************************************************************************/
    GameController.GetFirstAndBestGameStatistic = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/statistic/firstAndBest", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/statistic/bucket" and http method "POST" to call the back-end.
    
        * @param {GameFilterDto} filter
        * @returns {GameBucketStatDto[]}
    ******************************************************************************************************/
    GameController.GetBucketStatistics = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/statistic/bucket", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/invitePlayer/{userId}/{gameId}/{link}" and http method "POST" to call the back-end.
    
        * @param {string} userId
        * @param {string} gameId
        * @param {string} link
        * @returns {GameResultDto[]}
    ******************************************************************************************************/
    GameController.InvitePlayer = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/invitePlayer/{userId}/{gameId}/{link}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/recalculate/{quizId}" and http method "POST" to call the back-end.
    
        * @param {string} quizId
        * @returns {number}
    ******************************************************************************************************/
    GameController.RecalculateGames = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/recalculate/{quizId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/game/removePlayer/{mainGameId}/{userId}" and http method "POST" to call the back-end.
    
        * @param {string} mainGameId
        * @param {string} userId
        * @returns {void}
    ******************************************************************************************************/
    GameController.RemovePlayer = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/game/removePlayer/{mainGameId}/{userId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return GameController;
}());
export { GameController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=GameController.js.map